/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicBudgetCost extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicBudgetCost");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicBudgetCost.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicBudgetCost>): BackgroundJobPayloadForPeriodicBudgetCost {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicBudgetCost(), model);
        BackgroundJobPayloadForPeriodicBudgetCost.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicBudgetCost>): BackgroundJobPayloadForPeriodicBudgetCost {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicBudgetCost.newInstance(<BackgroundJobPayloadForPeriodicBudgetCost> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicBudgetCost) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicBudgetCost.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicBudgetCost): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicBudgetCost.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
